import { formatPercent, formatTwoDecimals, percentChange, roundToTwoDecimals } from '../../Utils/decimalUtils';
import { EMPTY_METRIC, signed, withSek } from './worksheetFormatters';

interface WorksheetTotalProps {
    label: string;
    original: number;
    next: number;
    hasQuantity: boolean;
    changeClassName: string;
}

const WorksheetTotal = ({ label, original, next, hasQuantity, changeClassName }: WorksheetTotalProps) => {
    if (!hasQuantity)
        return (
            <span className="body-sm">
                {label}: {EMPTY_METRIC}
            </span>
        );

    const diff = roundToTwoDecimals(next - original);

    return (
        <span className="body-sm">
            {label}: {withSek(original)}
            {diff !== 0 && (
                <>
                    {' → '}
                    <span className="semibold">{withSek(next)}</span>
                    <span className={`semibold ${changeClassName}`}>
                        {' '}
                        ({signed(diff)}
                        {formatTwoDecimals(diff)} / {signed(diff)}
                        {formatPercent(percentChange(original, next))})
                    </span>
                </>
            )}
        </span>
    );
};

export default WorksheetTotal;
